import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import Amplify from "aws-amplify";
import config from "./config";
import { API } from "aws-amplify";


Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: "notes",
        endpoint: config.apiGateway.Notes_URL,
        region: config.apiGateway.REGION
      },
      {
        name: "Gmail",
        endpoint: config.apiGateway.Gmail_URL,
        region: config.apiGateway.REGION
      },
      {
        name: "contacts",
        endpoint: config.apiGateway.Contacts_URL,
        region: config.apiGateway.REGION
      },
      {
        name: "users",
        endpoint: config.apiGateway.Users_URL,
        region: config.apiGateway.REGION
      },
    ]
  }
});


ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();


export async function finishGmailIntegration(code) {

  const authUser = await API.post("appGmail", "/authorize", { redirectOrigin: "exactify.net", code, tenantId: '' });

  const gmailEmailAddress = authUser.data.emailAddress;
  alert(gmailEmailAddress);
  console.log(gmailEmailAddress);
  // kick off setupWatches with emailAddress
}



// WEBPACK FOOTER //
// ./src/index.js